module.exports = __webpack_public_path__ + "media/configurations/ZOC_P-X-X-P-5c4109c4.png";